import React, { useRef, useState, useEffect, useMemo } from "react"
import { ArticlesPreviewType } from "../../types/mainModulTypes"
import { Navigation } from "swiper/modules"
import { Swiper as SwiperType } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import { API } from "../../constants/constants"
import BaseHeadline from "../common/BaseHeadline"
import BaseRichtext from "../common/BaseRichtext"
import BaseSubheadline from "../common/BaseSubheadline"
import PrimaryButton from "../common/PrimaryButton"
import { useNavigate } from "react-router-dom"

export default function ArticlesPreview(props: ArticlesPreviewType) {
    const orderedArticles = useMemo(() => {
        return [...props.articlesPreviewProvider].sort((a, b) => new Date(b.authored as string).getTime() - new Date(a.authored as string).getTime())
    }, [props?.articlesPreviewProvider])

    const swiperRef = useRef<SwiperType>()

    const [isBeginning, setIsBeginning] = useState(true)
    const [isEnd, setIsEnd] = useState(false)

    useEffect(() => {
        if (swiperRef.current) {
            setIsBeginning(swiperRef.current.isBeginning)
            setIsEnd(swiperRef.current.isEnd)
        }
    }, [])

    const navigate = useNavigate()

    return (
        <>
            {orderedArticles.length > 0 && (
                <div className="max-w-content mx-auto flex gap-4 justify-between relative items-center px-4">
                    <button
                        onClick={() => {
                            swiperRef.current?.slidePrev()
                            setIsBeginning(swiperRef.current?.isBeginning ?? true)
                            setIsEnd(swiperRef.current?.isEnd ?? false)
                        }}
                        disabled={isBeginning}
                        className={`w-0 h-0 border-t-[50px] border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] 
                ${isBeginning ? "border-l-gray-400 cursor-not-allowed" : "border-l-base-300"} rotate-180`}
                    />
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={50}
                        modules={[Navigation]}
                        onBeforeInit={(swiper: SwiperType) => {
                            swiperRef.current = swiper
                        }}
                        className="mySwiper max-w-content mx-auto">
                        {orderedArticles.map((item, index) => (
                            <SwiperSlide key={index} className="relative w-full max-w-full">
                                <div className="flex !flex-col sm:!flex-row gap-4 sm:!gap-8 w-full max-w-3xl mx-auto items-center">
                                    <img
                                        src={API + item.content.zigZagImage?.url}
                                        alt={item.content.zigZagImage?.description || item.content.zigZagImage?.name}
                                        className="!w-full !aspect-[5/3] sm:!w-5/12 sm:!aspect-[5/7] rounded-default object-cover"
                                    />
                                    <div className="!w-full sm:!w-6/12">
                                        <BaseHeadline headlineType={4} label={item.content.zigZagContentHeading} classProps="pb-2" />
                                        <BaseSubheadline label={item.content.zigZagContentSubHeading} classProps="pb-2" />
                                        <BaseRichtext content={item.content.zigZagContentText} classProps="pb-4" />
                                        <PrimaryButton
                                            text={"Mehr Erfahren"}
                                            onClick={() => {
                                                if (props.articlePreviewPageSelection?.content?.url.includes("https://")) {
                                                    window.open(
                                                        props.articlePreviewPageSelection?.content?.url +
                                                            "#" +
                                                            item.content.routePath.replace("/", ""),
                                                        "_blank"
                                                    )
                                                } else {
                                                    navigate(
                                                        props.articlePreviewPageSelection?.content?.url +
                                                            "#" +
                                                            item.content.routePath.replace("/", "")
                                                    )
                                                }
                                            }}
                                            active
                                            classProps="w-full sm:w-fit"
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button
                        onClick={() => {
                            swiperRef.current?.slideNext()
                            setIsBeginning(swiperRef.current?.isBeginning ?? true)
                            setIsEnd(swiperRef.current?.isEnd ?? false)
                        }}
                        disabled={isEnd}
                        className={`w-0 h-0 border-t-[50px] border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] 
                ${isEnd ? "border-l-gray-400 cursor-not-allowed" : "border-l-base-300"}`}
                    />
                </div>
            )}
        </>
    )
}
